import ctl from '@netlify/classnames-template-literals';

const iconBaseStyle = ctl(`
  fill-white
  rounded-full
  text-2xl
`);

export const rowStyle = ctl(`
  grid
  grid-cols-3
  items-center
`);

export const successIconStyle = ctl(`
  ${iconBaseStyle}
  bg-green-ncs
`);

export const errorIconStyle = ctl(`
  ${iconBaseStyle}
  bg-american-pink
`);
